module.exports = __webpack_public_path__ + "assets/img/zoom_in_icon.cec1264a.svg";